import PropTypes from "prop-types";
import { Popup } from "semantic-ui-react";
import { Left, Value } from "./styles";

export const LeftWithHover = ({ content, theme, width, category }) => {
  return (
    <Popup
      basic
      content={`${content} hours ${category}`}
      trigger={
        <Left width={width} style={theme}>
          <Value>{content}</Value>
        </Left>
      }
    />
  );
};

LeftWithHover.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
  width: PropTypes.PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
};
